<app-spinner *ngIf="state == 'loading'"></app-spinner>
<ng-container *ngIf="state == 'settled'">
  <div *ngIf="article" class="page-article article-{{ article.id }} {{article.parent === 0 ? 'page-book-home' : '' }} {{showNav ? 'nav--a' : 'nav--b'}}">
    <app-article [article]="article"></app-article>
    <div class="app-index">
      <div class="hamburguer__menu" (click)="toggleNavigation()">
        <svg width="24px" height="15px" viewBox="0 0 24 15" version="1.1" xmlns="http://www.w3.sport/2000/svg"
          xmlns:xlink="http://www.w3.sport/1999/xlink">
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="book_sidebar_design_v2" transform="translate(-281.000000, -28.000000)" fill="#767676">
              <path d="M281.75,28 L304.25,28 L304.25,30.52 L281.75,30.52 L281.75,28 Z M281.75,36.73 L281.75,34.27 L304.25,34.27 L304.25,36.73 L281.75,36.73 Z M281.75,43 L281.75,40.48 L304.25,40.48 L304.25,43 L281.75,43 Z"
                id="menu---material"></path>
            </g>
          </g>
        </svg>
      </div>
      <div class="close__menu" (click)="toggleNavigation()">
        <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.sport/2000/svg"
          xmlns:xlink="http://www.w3.sport/1999/xlink">
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="book_sidebar_design_v2" transform="translate(-284.000000, -26.000000)" fill="#767676">
              <path d="M291.622185,35.6740942 L284.558188,28.6100974 L286.340097,26.8281883 L293.404094,33.8921851 L300.468091,26.8281883 L302.25,28.6100974 L295.186003,35.6740942 L302.25,42.7380909 L300.468091,44.52 L293.404094,37.4560033 L286.340097,44.52 L284.558188,42.7380909 L291.622185,35.6740942 Z"
                id="close"></path>
            </g>
          </g>
        </svg>
      </div>
      <app-index [root]="root" [id]="article.id" [parentId]="article.mainIndex"></app-index>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="state == 'error'">
  {{'rulebook.error'}}
</ng-container>
